import * as AC from './actionTypes';
import _ from 'lodash';
import axios from 'components/AppRequest';
import sortBy from 'lodash/sortBy';

export const refreshCustomerAddressesList = () => {
  return {
    type: AC.REFRESH_CUSTOMER_ADDRESSES_LIST,
  }
}

export const fetchCustomerAddresses = () => {
  return (dispatch, getState) => {
    if (getState().app.isLogged) {
      axios.get('/pwa/customer/fetch-addresses')
        .then(response => {
          var addresses = response.data;
          var sortedAddresses = sortBy(addresses, (o) => {
            if (o.is_bus_stop) {
              return o.bus_stop_name;
            } else {
              return o.name;
            }
          });
          dispatch(setCustomerAddresses(sortedAddresses));
        })
        .catch(err => {
          console.log("err", err);
        });
    }
  }
}

export const fetchBusStops = () => {
  return (dispatch, getState) => {
    axios.get('/pwa/reservation/bus-stop-list')
      .then(response => {
        dispatch({
          type: AC.SET_BUS_STOP_LIST,
          payload: response.data
        })
      })
      .catch(err => {
        console.log("err", err);
      });
  }
}

export const setCustomerAddresses = (addresses) => {
  return {
    type: AC.SET_CUSTOMER_ADDRESSES,
    addresses
  }
}

export const setReservationToEdit = (reservation) => {
  return (dispatch, getState) => {
    dispatch({
      type: AC.SET_RESERVATION_TO_EDIT,
      reservation
    });
  }
}

export const setKidsSafetyInReservationEdit = (name, number) => {
  var hash = {}
  hash[name] = number;
  return {
    type: AC.SET_KIDS_SAFETY_IN_RESERVATION,
    value: hash
  };
}

export const setChildrenNumber = (number) => {
  return (dispatch, getState) => {
    dispatch({
      type: AC.SET_CHILDREN_NUMBER_IN_RESERVATION_EDIT,
      number,
    });
    dispatch(resetKidsSafetyInReservationEdit());
    dispatch(setNewPrice());
  }
}

export const setAdultsNumber = (number) => {
  return (dispatch, getState) => {
    dispatch({
      type: AC.SET_ADULTS_NUMBER_IN_RESERVATION_EDIT,
      number,
    });
    dispatch(setNewPrice());
  }
}

export const setStudentsNumber = (number) => {
  return (dispatch, getState) => {
    dispatch({
      type: AC.SET_STUDENTS_NUMBER_IN_RESERVATION_EDIT,
      number,
    });
    dispatch(setNewPrice());
  }
}

export const setNewPrice = () => {
  return (dispatch, getState) => {
    dispatch({
      type: AC.SET_NEW_PRICE_RESERVATION_EDIT,
      priceList: getState().service.priceList
    });
  }
}

export const setAddressInReservationEdit = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: AC.SET_ADDRESS_IN_RESERVATION_EDIT,
      value
    });
    dispatch(setNewPrice());
  }
}

export const setPriceList = (list) => {
  return {
    type: AC.SET_PRICE_LIST,
    list
  };
}

export const setCardIdInReservationEdit = (value) => {
  return {
    type: AC.SET_CARD_ID_IN_RESERVATION_EDIT,
    value
  }
}

export const resetReservationUpdateData = () => {
  return {
    type: AC.RESET_RESERVATION_UPDATE_DATA,
  }
}

export const resetKidsSafetyInReservationEdit = () => {
  return {
    type: AC.RESET_KIDS_SAFETY_IN_RESERVATION_EDIT,
  }
}

export const fetchPriceList = (value) => {
  return (dispatch, getState) => {
    axios.get('/pwa/reservation/fetch-prices')
      .then(response => {
        dispatch(setPriceList(response.data));
      })
      .catch(err => {
        console.log("err", err);
      });
  }
}

export const createNotification = (params) => {
  return {
    type: AC.CREATE_NOTIFICATION,
    params
  }
}

export const createSuccessNotification = (params) => {
  params["type"] = "success";
  return (dispatch, getState) => {
    dispatch({
      type: AC.CREATE_NOTIFICATION,
      params
    });
  }
}

export const createErrorNotification = (params) => {
  params["type"] = "danger";
  return (dispatch, getState) => {
    dispatch({
      type: AC.CREATE_NOTIFICATION,
      params
    });
  }
}

export const createWarningNotification = (params) => {
  params["type"] = "warning";
  return (dispatch, getState) => {
    dispatch({
      type: AC.CREATE_NOTIFICATION,
      params
    });
  }
}

export const setDashboardReservations = (reservations) => {
  return {
    type: AC.SET_DASHBOARD_RESERVATIONS,
    reservations
  }
}

export const setMyTrips = (trips) => {
  return {
    type: AC.SET_MY_TRIPS,
    trips
  }
}

export const cancelReservation = (
  id,
  reservationDirection,
  reservationType,
  cancelledWithRefund
) => {
  return {
    type: AC.CANCEL_RESERVATION,
    id,
    reservationDirection,
    reservationType,
    cancelledWithRefund
  }
}

export const setReservationToReview = (reservation) => {
  return {
    type: AC.SET_RESERVATION_TO_REVIEW,
    reservation
  }
}

export const hideReviewFormInReservation = (id) => {
  return {
    type: AC.HIDE_REVIEW_FORM_IN_RESERVATION,
    id
  }
}

export const overrideReservation = (reservation) => {
  return {
    type: AC.OVERRIDE_RESERVATION,
    reservation
  }
}

export const setFilterDateInTrips = (date) => {
  return {
    type: AC.SET_FILTER_DATE_IN_TRIPS,
    date
  }
}
